<script>
import Layout from "@/views/layouts/LayoutAdminPublic";
import NotFound from "@/views/components/ComponentNotFound";

export default {
  name: "PageNotFound",

  metaInfo() {
    return {
      title: this.$t("r_page_pageNotFound")
    };
  },

  components: { Layout, NotFound }
};
</script>

<template>
  <layout>
    <not-found />
  </layout>
</template>
